// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5743) return "static/chunks/5743.9a5f85bb48c7ca7a.js";
	if (chunkId === 4973) return "static/chunks/c9c1c5d6.7a46178b6bf8608e.js";
	if (chunkId === 9160) return "static/chunks/9160.84672fafacff594e.js";
	if (chunkId === 9613) return "static/chunks/9613.7281cc38a9d118d5.js";
	if (chunkId === 227) return "static/chunks/227.9729ae3e9617b1e1.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1843":"afe70d2112f4d174","2425":"9338fc33b132241f","3781":"57d6b8a6a7c6667f","4208":"3d6a0bb4ff3c2783","4693":"fadac9ae1d12a87c","7043":"b0ef56ff7757108c","8260":"0bb0751bb9fe6bd3","9056":"34d2b75c70873ac2"}[chunkId] + ".js";
};